// extracted by mini-css-extract-plugin
export default {"loaderOverlay":"style_loaderOverlay__qx8Xc","error":"style_error__Mb+vC","closeBtn":"style_closeBtn__8t56R"};